import { openComponentInPopup } from "../common";
import Form from "../form";
import $ from "jquery";

export class ResetChangePasswordForm {

    constructor() { }

    process(event: Event): void {
        const formElement = document.querySelector('[data-component=ForgotPasswordReset] form') as HTMLFormElement;

        const actionUrl = formElement.getAttribute('action');
        const form = new Form(actionUrl, formElement, 
            () => null,
            (html: string) => this.onModelError(html));

        form.process(event);
    }

    private onModelError(html: string): void {
        const viewcomponent =  document.querySelector('[data-component=ForgotPasswordReset]');
        viewcomponent.innerHTML = html;

        const formToRefresh = document.querySelector('[data-component=ForgotPasswordReset] form');
        $.validator.unobtrusive.parse(formToRefresh);
    }

}
